// extracted by mini-css-extract-plugin
export var badge = "IdXboxBadge-module__badge___vvd+Z";
export var icon = "IdXboxBadge-module__icon___D91Sc";